function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  /* margin-right: 0; */\n  &:hover {\n    path {\n      fill: #d7bef2;\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import styled from "styled-components";
import Svg from "../Svg";
var LanguageIconContainer = styled(Svg).withConfig({
    componentId: "sc-48dd1deb-0"
})(_templateObject());
var Icon = function(props) {
    return /*#__PURE__*/ _jsx(LanguageIconContainer, _objectSpread({
        // width="28"
        // height="28"
        viewBox: "0 0 28 28",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        children: /*#__PURE__*/ _jsx("path", {
            d: "M13.7362 0C6.14625 0 0 6.16 0 13.75C0 21.34 6.14625 27.5 13.7362 27.5C21.34 27.5 27.5 21.34 27.5 13.75C27.5 6.16 21.34 0 13.7362 0ZM23.265 8.25H19.2088C18.7784 6.547 18.1412 4.90311 17.3113 3.355C19.8194 4.2185 21.9329 5.95612 23.265 8.25ZM13.75 2.805C14.8912 4.455 15.785 6.28375 16.3762 8.25H11.1238C11.715 6.28375 12.6088 4.455 13.75 2.805ZM3.1075 16.5C2.8875 15.62 2.75 14.6987 2.75 13.75C2.75 12.8013 2.8875 11.88 3.1075 11H7.755C7.645 11.9075 7.5625 12.815 7.5625 13.75C7.5625 14.685 7.645 15.5925 7.755 16.5H3.1075ZM4.235 19.25H8.29125C8.73125 20.9688 9.36375 22.6187 10.1887 24.145C7.67796 23.2862 5.56302 21.5474 4.235 19.25V19.25ZM8.29125 8.25H4.235C5.56302 5.95262 7.67796 4.21378 10.1887 3.355C9.35884 4.90311 8.72159 6.547 8.29125 8.25V8.25ZM13.75 24.695C12.6088 23.045 11.715 21.2162 11.1238 19.25H16.3762C15.785 21.2162 14.8912 23.045 13.75 24.695ZM16.9675 16.5H10.5325C10.4087 15.5925 10.3125 14.685 10.3125 13.75C10.3125 12.815 10.4087 11.8937 10.5325 11H16.9675C17.0913 11.8937 17.1875 12.815 17.1875 13.75C17.1875 14.685 17.0913 15.5925 16.9675 16.5ZM17.3113 24.145C18.1363 22.6187 18.7688 20.9688 19.2088 19.25H23.265C21.9329 21.5439 19.8194 23.2815 17.3113 24.145V24.145ZM19.745 16.5C19.855 15.5925 19.9375 14.685 19.9375 13.75C19.9375 12.815 19.855 11.9075 19.745 11H24.3925C24.6125 11.88 24.75 12.8013 24.75 13.75C24.75 14.6987 24.6125 15.62 24.3925 16.5H19.745Z",
            fill: "#333333"
        })
    }));
};
export default Icon;
